import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { MemberInterface } from '@interface/member/member.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialMembersState } from './members.initial-state';

export const membersSlice = createSlice({
  name: 'members',
  initialState: initialMembersState,
  reducers: {
    ...baseReducerActions(initialMembersState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<MemberInterface[]>>) => {
      state.data = mapifyPayload(payload.data);
    },
  },
});

export const membersActions = membersSlice.actions;
